import { render, staticRenderFns } from "./MicIcon.vue?vue&type=template&id=155b5781"
import script from "./MicIcon.vue?vue&type=script&lang=js"
export * from "./MicIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports